import React from "react";


const Loader = () => {
  return (
      <div className="ui active dimmer">
        <div className="ui text loader">Fetching feed...</div>
      </div>
  );
};

export default Loader;
